import React, { useState, useEffect } from "react";
import { Select } from "antd";
import { DateBreakdown } from "../../../../constants";
import moment from "moment";
import { maxDisabledValue } from "../../../../constants";

export const FilterOverTimeSelector = ({
                                           selectedDateName,
                                           setSelectedDateName,
                                           metaDataDate,
                                           interval,
                                           setInterval,
                                           filters,
                                           selectedDateField
                                       }) => {
    const [disabledIntervals, setDisabledIntervals] = useState({});

    useEffect(() => {
        const selectedFilter = filters.find((f) => f.name === selectedDateName);
        if (selectedFilter) {
            const iterations = calculateIterationsForAllIntervals(selectedFilter);
            const firstEnabledInterval =
                Object.keys(iterations).find((key) => !iterations[key].disabled) ||
                "day";
            if (!interval) setInterval(firstEnabledInterval);
            setDisabledIntervals(iterations);
        }else{
            const iterations = calculateIterationsForAllIntervals(selectedDateField);
            const firstEnabledInterval =
                Object.keys(iterations).find((key) => !iterations[key].disabled) ||
                "day";
            if (!interval) setInterval(firstEnabledInterval);
            setDisabledIntervals(iterations);
        }
    }, [selectedDateName, filters]);

    const calculateIterationsForInterval = (minimum, maximum, interval) => {
        const startDate = moment(minimum);
        const endDate = moment(maximum);

        if (!startDate.isValid() || !endDate.isValid()) {
            return 0;
        }

        return endDate.diff(startDate, interval) + 1;
    };

    const calculateIterationsForAllIntervals = (filter) => {
        const { minimum, maximum } = filter;

        if (!minimum || !maximum) {
            return DateBreakdown.INTERVALS.reduce((acc, interval) => {
                acc[interval] = { disabled: true, count: 0 };
                return acc;
            }, {});
        }

        return DateBreakdown.INTERVALS.reduce((acc, interval) => {
            const count = calculateIterationsForInterval(minimum, maximum, interval);
            acc[interval] = { disabled: count <= 0 || count > maxDisabledValue, count };
            return acc;
        }, {});
    };

    const intervalOptions = DateBreakdown.INTERVALS.map((interval) => ({
        label: interval.charAt(0).toUpperCase() + interval.slice(1),
        value: interval,
        disabled: disabledIntervals[interval]?.disabled,
    }));

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Select
                showSearch
                style={{ width: 150 }}
                placeholder="Select Filter Date Field"
                value={selectedDateName || metaDataDate[0]?.name}
                onChange={(value) => setSelectedDateName(value)}
                options={metaDataDate.map((date) => ({
                    label: date.name,
                    value: date.name,
                }))}
                size="small"
            />
            <label>Select Interval</label>
            <Select
                showSearch
                style={{ width: 150 }}
                placeholder="Select Interval"
                value={interval}
                onChange={(value) => setInterval(value)}
                options={intervalOptions}
                size="small"
            />
        </div>
    );
};
